import { render, staticRenderFns } from "./ChangePrice.vue?vue&type=template&id=7383969a&scoped=true"
import script from "./ChangePrice.vue?vue&type=script&lang=js"
export * from "./ChangePrice.vue?vue&type=script&lang=js"
import style0 from "./ChangePrice.vue?vue&type=style&index=0&id=7383969a&prod&lang=scss&scoped=true"
import style1 from "./ChangePrice.vue?vue&type=style&index=1&id=7383969a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7383969a",
  null
  
)

export default component.exports